import { combineReducers } from '@reduxjs/toolkit';
import { reducer as absenceSupervisorReducer } from './absence';
import { reducer as dayOffSupervisorReducer } from './dayOff';
import { reducer as vacationApplicationSupervisorReducer } from './vacationApplication';
import { reducer as vacationScheduleApplicationSupervisorReducer } from './vacationSchedule';

export const supervisorReducer = combineReducers({
  absenceSupervisorReducer,
  dayOffSupervisorReducer,
  vacationApplicationSupervisorReducer,
  vacationScheduleApplicationSupervisorReducer,
});
